import { UiKitPriceBase } from '@/fo/ui/kit/price/base';

import { ButtonBuy } from '../components/ButtonBuy/ButtonBuy';

import { styles } from './UiProductButtonBuy.styles';

export interface UiProductButtonBuyProps {
  isInCart?: boolean;
  className?: string;
  classNamePrice?: string;
  classNamePriceValue?: string;
  classNamePriceOldValue?: string;
  price: number;
  oldPrice?: number | null;
  onClick?: React.HTMLAttributes<HTMLDivElement>['onClick'];
  loading?: boolean;
}

/**
 * Компонент кнопка купить для плиток
 *
 * Необходимо указать класс group/tile для всей плитки,
 * чтобы при наведении на неё кнопка купить становилась видимой
 */
export function UiProductButtonBuy({
  isInCart = false,
  className,
  classNamePrice,
  classNamePriceValue,
  classNamePriceOldValue,
  price,
  oldPrice,
  onClick,
  loading = false
}: UiProductButtonBuyProps) {
  const slots = styles({ isInCart });

  return (
    <div
      className={slots.base({ className, null: price === 0 })}
      onClick={onClick}
      data-mobile-app-hidden="commerce"
    >
      <UiKitPriceBase
        value={price}
        oldValue={oldPrice}
        className={slots.prices({ className: classNamePrice })}
        classNameValue={slots.price({ className: classNamePriceValue })}
        classNameOldValue={slots.oldPrice({
          className: classNamePriceOldValue
        })}
      />
      <ButtonBuy
        className={slots.button()}
        isInCart={isInCart}
        loading={loading}
      />
    </div>
  );
}
